import type { Fragment } from '../translations';

export const landscape: Fragment = {
  fr: {
    'land.title': 'Vue d’ensemble des processus',
    'land.subtitle': 'Situer chaque modèle dans l’organisation et suivre son parcours au CdE.',
    'land.repository': 'Parcourir le répertoire',
    'land.tier.core': 'Cœur de métier',
    'land.tier.management': 'Management',
    'land.tier.support': 'Support',
    'land.tier.unclassified': 'À classer',
    'land.purpose.core': 'Parcours participant, expertise et relation mandant',
    'land.purpose.management': 'Orientation, priorités et pilotage',
    'land.purpose.support': 'Ressources et continuité des activités',
    'land.purpose.unclassified': 'Emplacement à définir à la réception',
    'land.steps': 'Parcours CdE',
    'land.stepsHint': 'Modèles et brouillons avec un cycle suivi dans l’application',
    'land.view.all': 'Tous',
    'land.view.inbox': 'Réception / inbox',
    'land.view.hold': 'En pause',
    'land.view.untracked': 'Sans cycle CdE',
    'land.proposed': 'Classement proposé',
    'land.proposalHint': 'Aperçu de reclassement par finalité. Les chemins affichés restent les chemins actuels. Les revenus et les remplacements RM/RP demandent un arbitrage de périmètre avant déplacement.',
    'land.count': '{n} modèles et brouillons affichés',
    'land.clear': 'Effacer catégorie et étape',
    'land.technical': 'Inclure les fichiers techniques',
    'land.modelling': 'Modélisation',
    'land.cycle': 'Étape CdE',
    'land.people': 'Responsabilités',
    'land.pmo': 'Origine PMO',
    'land.noArea': 'Domaine à préciser',
    'land.noFile': 'Brouillon sans modèle lié',
    'land.sourceDate': 'CSV du {date}',
    'land.notes': 'Notes du suivi',
    'land.priority': 'Priorité',
    'land.assignment': 'Attribution à préciser',
    'land.reference': 'Référence',
    'land.noTracking': 'Non renseigné dans le CSV',
    'land.noCycle': 'Aucun cycle enregistré',
    'land.consultant': 'Consultant CdE',
    'land.owner': 'Responsable du processus',
    'land.csvOwner': 'Suivi CSV',
    'land.unassigned': 'À attribuer',
    'land.milestone': 'Jalon {id}',
    'land.noPmo': 'Sans lien PMO',
    'land.state.on_hold': 'En pause',
    'land.state.cancelled': 'Annulé',
    'land.state.superseded': 'Remplacé',
    'land.state.live': 'En service',
    'land.empty': 'Aucun modèle ne correspond à ces filtres.',
    'land.reconciliation': 'Reprise du suivi existant',
    'land.snapshot': 'État au {date} : {matched} entrées sur {total} rapprochées d’un fichier par nom exact normalisé.',
    'land.snapshotHint': 'Le pourcentage décrit le suivi historique de modélisation. Il ne valide aucune étape CdE. Les noms différents restent à rapprocher ; aucune validation ni personne responsable du processus n’est déduite du CSV.',
    'land.unmatched': '{n} entrées à rapprocher',
    'land.error': 'La vue d’ensemble n’a pas pu être chargée.',
    'land.retry': 'Réessayer',
    'land.reason.offer': 'Proposition : cycle de vie de l’offre',
    'land.reason.mandant': 'Proposition : relation mandant et contractualisation',
    'land.reason.staff': 'Proposition : suivi des ressources humaines',
    'land.reason.participant': 'Proposition : parcours participant',
    'land.reason.steering': 'Proposition : pilotage financier',
    'land.reason.revenue-review': 'À arbitrer : prestation mandant ou opération comptable',
    'land.reason.continuity-review': 'À arbitrer : continuité de service ou rôle dans le suivi',
  },
  en: {},
};
